import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../../pages/produtos/produtos.modelview';

/**
 * Generated class for the ProdutoFiltroPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'produtoFiltro',
})
export class ProdutoFiltroPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: Array<Product>, ...args) {


    if (value != undefined) {

      let key = args[0].key
      let tipo = args[0].tipo

      let keyFiltred = []
      if (key != undefined) {
        keyFiltred = value.filter((produto) => { return produto.name.toLowerCase().indexOf(key.toLowerCase()) >= 0 })
      } else {
        keyFiltred = value
      }

      if (tipo != undefined) {
        return keyFiltred.filter((produto) => (produto.tipo_produto ? produto.tipo_produto.toLowerCase() : "") == tipo.toLowerCase())
      } else {
        return keyFiltred
      }

    } else {
      return []
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/produto-filtro/produto-filtro.ts